module.exports = __webpack_public_path__ + "img/ZFR3_1.1cd6a05a.jpg";